import $ from 'jquery';

export default function () {

  function init() {
    _setUpListeners();
  }

  function _setUpListeners() {
    $("#energy-calculator-form").on("submit", function() {
      return $.calculateEnergy();
    });
  }

  $.calculateEnergy = function() {
    var $model = document.ecf.model.value;
    var $climate = document.ecf.climate.value;
    var $error = '';
    var $cost = 0.00;

    var $models = {
      "vista"     : [13.92,18.28,17.81,16.31,20.67,22.99,28.13,27.63,36.61,64.55],
      "grandee"   : [13.92,18.28,17.81,16.31,20.67,22.99,28.13,27.63,36.61,64.55],
      "envoy"     : [11.61,15.53,15.33,14.17,18.09,20.24,24.88,24.54,32.62,57.68],
      "aria"      : [10.98,14.61,14.37,13.25,16.88,18.86,23.14,22.80,30.29,53.51],
      "vanguard"  : [11.22,15.03,14.85,13.74,17.56,19.65,24.17,23.84,31.70,56.07],
      "sovereign" : [11.07,14.70,14.44,13.30,16.93,18.90,23.19,22.84,30.33,53.57],
      "prodigy"   : [10.66,14.21,14.00,12.92,16.47,18.41,22.61,22.28,29.60,52.31],
      "jetsetter" : [10.27,13.74,13.57,12.55,16.02,17.93,22.03,21.73,28.89,51.08]
    }

    if ($model == '' && $climate == '') {
      $error = 'Please select a spa model, climate and rate.';
    } else if ($model == '') {
      $error = 'Please select a spa model';
    } else if ($climate == '') {
      $error = 'Please select a climate and rate';
    } else {
      $cost = $models[$model][$climate];
    }

    //Handle errors and success
    if($error){
      $(".energy-calculator-result").css("display","block");
      $(".energy-calculator-result h3").text($error);
    } else {
      $(".energy-calculator-result").fadeIn();
      $(".energy-calculator-result h3").text("Your monthly cost is estimated to be:");
      if($climate == 7){
        $(".energy-calculator-result span").text("C$" + $cost.toFixed(2));
      } else {
        $(".energy-calculator-result span").text("$" + $cost.toFixed(2));
      }
    }

    return false;
  }

  return {
    init: init
  }
}